<form class="searchbar-form cell auto grid-x grid-margin-x align-middle align-right">
    <label class="cell shrink searchbar-formItem _quickSearch">
        <span>{{'search.device.search' | translate}}</span>
        <input #searchField type="text" [(ngModel)]="modelOrName"
               (keyup)='keyUp.next($event)'
               [ngModelOptions]="{standalone: true}">
    </label>
</form>
